import React from 'react'

const Txt = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/txt',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g
      fill='none'
      fillRule='evenodd'
      transform='translate(1 1)'
    >
      <rect
        fill={primaryColor}
        height='90%'
        rx={2}
        width='90%'
      />
      <path
        d='M3 3h12v1H3zM3 5h9v1H3zM3 7h12v1H3zM3 9h9v1H3zM3 11h12v1H3zM3 13h12v1H3z'
        fill={secondaryColor}
      />
    </g>
  </svg>
)

export default Txt
